import MarkdownStrong from './component.jsx'
export default MarkdownStrong
